import React from 'react';
import _ResponsiveContentTab from 'src/components/Modules/ResponsiveContentTab';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';
// import { separateSymbol } from 'src/tools/constant';
// import { errKeys } from 'src/constrains/DraggableModules/tools';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';

const ResponsiveContentTab = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnReselect,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    extraProps,
    handleItemOnAdd,
    handleOnItemDelete,
  } = props || {};
  const { breakpoint } = extraProps || {};
  const { options, animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  // const inUsePages = get(options, 'inUsePages') || [];
  // const pendingPages = get(options, 'pendingPages') || [];
  // const previousPages = get(options, 'previousPages') || [];
  // const contentPages = [...inUsePages, ...pendingPages, ...previousPages];
  // const layersKey = errKeys.ResponsivePoster.imageLayers;
  // const layersError = Object.keys(specificError || {}).reduce((pre, key) => {
  //   // console.log('key', key);
  //   const isLayerError =
  //     key.startsWith(layersKey) && (specificError[key] || []).length > 0;
  //   if (isLayerError) {
  //     const id = key.split(separateSymbol)[1];
  //     return { ...pre, [id]: true };
  //   }
  //   return pre;
  // }, {});
  return (
    <_ResponsiveContentTab
      contentPageList={options}
      onItemDelete={handleOnItemDelete}
      staticData={staticData}
      tabs={dynamicData}
      onItemAdd={handleItemOnAdd}
      onItemReselect={handleOnReselect}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
      breakpoint={breakpoint}
      animations={animations}
      hoverAnimations={hoverAnimations}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveContentTab);
